// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
const { connect } = require('react-redux')
// Common Client V2 imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
// Sibling imports
const { defaultFeedSelectors } = require('./selectors')

module.exports = {
  createFeedAwareAppFooter,
  default: createFeedAwareAppFooter(defaultFeedSelectors)
}

function createFeedAwareAppFooter(feedSelectors) {
  function FeedAwareAppFooter(props) {
    if (!props.isEndOfStream) {
      return null
    }
    return React.createElement(AppFooter)
  }

  FeedAwareAppFooter.propTypes = {
    isEndOfStream: PropTypes.bool
  }

  function mapStateToProps(state) {
    return {
      isEndOfStream: !feedSelectors.getNextPageUrl(state)
    }
  }

  return connect(
    mapStateToProps
  )(
    ImmutableToJS(
      FeedAwareAppFooter
    )
  )
}
